import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { InlineSelect } from "@/components/ui/inline-select"
import { Label } from "@/components/ui/label"
import { t } from "@/lib/i18n"
import { patchInline } from "@/lib/inline-update"
import { TimeZoneOption } from "@/lib/time-zone"

type Props = {
  timeZone: string
  timezones: TimeZoneOption[]
}

export function TimeZoneSelector({ timeZone, timezones }: Props) {
  // Keep the stored zone selectable even when it is a valid IANA identifier
  // that is not part of the curated options list.
  const options = !timeZone || timezones.some((option) => option.value === timeZone)
    ? timezones
    : [{ value: timeZone, label: timeZone }, ...timezones]

  return (
    <Card variant="borderless">
      <CardHeader>
        <CardTitle>{t("ui.react.components.features.profiles.time_zone_selector.label")}</CardTitle>
        <CardDescription>{t("ui.react.components.features.profiles.time_zone_selector.description")}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <Label htmlFor="time_zone">{t("ui.react.components.features.profiles.time_zone_selector.label")}</Label>
          <InlineSelect
            id="time_zone"
            className="w-full"
            data-testid="time-zone-select-trigger"
            value={timeZone}
            options={options}
            onSubmit={(value) => patchInline("/profile/settings", { time_zone: value })}
          />
        </div>
      </CardContent>
    </Card>
  )
}
